<h2 mat-dialog-title>Adressen aus Text importieren</h2>

<mat-dialog-content class="address-import-content">
  <p class="hint">
    Fügen Sie hier beliebigen Text ein (E-Mails, Tourenlisten, Notizen). Erkannte Adressen werden automatisch extrahiert.
  </p>

  <textarea
    class="form-control address-textarea"
    rows="10"
    [(ngModel)]="inputText"
    (ngModelChange)="refreshPreview()"
    placeholder="z. B. Musterstraße 12, 20095 Hamburg&#10;Beispielweg 3, 80331 München"
  ></textarea>

  <div class="preview-header">
    <strong>Erkannte Adressen ({{ parsedAddresses.length }})</strong>
  </div>

  <ul class="preview-list" *ngIf="parsedAddresses.length; else noAddresses">
    <li *ngFor="let addr of parsedAddresses">{{ addr.text }}</li>
  </ul>

  <ng-template #noAddresses>
    <p class="text-muted no-addresses">Noch keine Adressen erkannt.</p>
  </ng-template>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button type="button" mat-button (click)="cancel()">Abbrechen</button>
  <button type="button" mat-raised-button color="primary" [disabled]="parsedAddresses.length === 0" (click)="confirm()">
    Adressen übernehmen
  </button>
</mat-dialog-actions>
